module.exports = __webpack_public_path__ + "img/5-1.0616e564.svg";